module.exports = __webpack_public_path__ + "static/media/New-Mumbai.43569955.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/New-Mumbai.jpg
// module id = 898
// module chunks = 0